import PropTypes from 'prop-types';
import React, {memo} from 'react';

import Full from './variants/Full.jsx';
import Mark from './variants/Mark.jsx';

/**
 * Planet Logo component
 */
export const Logo = ({mark, styles, ...props}) => {
  const renderComponent = () => {
    let Component;
    switch (mark) {
      case true:
        Component = Mark;
        break;
      case false:
        Component = Full;
        break;
      default:
        Component = Full;
    }
    return <Component style={{height: 100, ...styles}} {...props} />;
  };

  return renderComponent();
};

Logo.propTypes = {
  /**
   Displays mark variant
  */
  mark: PropTypes.bool,
  /**
   Custom CSS styles object
  */
  styles: PropTypes.object,
};

/**
 * Primary UI component for user interaction
 */
export default memo(Logo);
